const RelationalModel = require('../extensions/relational-model.js');
const RelationalCollection = require('../extensions/relational-collection.js');
const moment = require('moment');
const parameters = require('./parameters.js');

const Activity = RelationalModel.extend({
  mutators: {
    duration() {
      const duration = moment.duration(this._get('duration'));
      return duration.asMinutes() ? duration.asMinutes() : 15;
    },
    color() {
      return this._get('color') ? this._get('color') : '#e1e1e1';
    },
    imageUrl() {
      const storageUrl = parameters.get('api_storage_url');
      return this._has('storedFileId')
        ? storageUrl.replace('{fileId}', this._get('storedFileId'))
        : 'img/logo-resamania-inline.png';
    }
  }
});

const ActivityCollection = RelationalCollection.extend({
  model: Activity,
  url() {
    return `${parameters.get('api_base_url')}/${parameters.get('client_token')}/activities`;
  }
});

module.exports = new ActivityCollection();



// WEBPACK FOOTER //
// ./src/data/activities.js